import { Card, CardBody, CardHeader, Col, FloatingLabel, FormCheck, FormControl, Row } from "react-bootstrap";
import { MdOutlineOilBarrel, MdOutlineQuestionMark, MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import CommonUtils from "../../utils/common";
import Validator from "../../services/Validator";

const AnlageRegisterElvCard = ({ anlage, data, setData, errors, setErrors }) => {

    const VALIDATOR = new Validator(); // Validator class 
    const UTILS = new CommonUtils(); // Common utils class
    var bg = "bg-secondary"; // default header bachgraound
    var defaultIconSize = 30; // default icon size
    var icon = <MdOutlineQuestionMark size={defaultIconSize} />; // default icon
    var hasSecondZaehler = anlage.x_zaehlpunktnummer_02 !== "False" && anlage.x_zaehlpunktnummer_02 !== "";
    
    // switch bg and icon according to Anlage type
    switch (anlage.x_studio_field_3eKe0) {
        case "Strom":
            bg = "bg-energo";
            icon = <SlEnergy size={defaultIconSize} />
            break;
        case "Gas":
            bg = "bg-info";
            icon = <TbFlame size={defaultIconSize} />
            break;
        case "Oil":
            bg = "bg-danger";
            icon = <MdOutlineOilBarrel size={defaultIconSize} />
            break;
        case "Strom-Einspeisung":
            bg = "bg-warning";
            icon = <MdOutlineSolarPower size={defaultIconSize} />
            break;
        default:
            bg = "bg-secondary";
            icon = <MdOutlineQuestionMark size={defaultIconSize} />
    }

    return (
        <Card key={`anlageRegElvCard-${anlage.id}`} style={{borderRadius: 15, overflow: "hidden"}} className="shadow-lg">
            <CardHeader className={`${bg} text-white`}>
                <div className="d-flex justify-content-between">
                    <div>
                        <div className="border border-2 rounded-circle energo-card-header-icon">{icon}</div>
                        <div className="adjust-font-on-small energo-card-header-icon-text">{anlage.x_studio_field_3eKe0}</div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <div className="hide-on-small">Anlagennummer ENERGO:</div>
                        <span style={{fontSize: 30, fontWeight: 300}}>{anlage.x_studio_field_mWMGR}</span>
                    </div>
                </div>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col>
                        <p>Energieform: &nbsp; <span className="text-muted">{anlage.x_studio_field_3eKe0}</span></p>
                        <p>Anlagennummer ENERGO: &nbsp; <span className="text-muted">{anlage.x_studio_field_mWMGR}</span></p>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md={hasSecondZaehler? "6":"12"} xl={hasSecondZaehler? "6":"12"} className={hasSecondZaehler? "border-right": null}>
                        <p className="text-energo text-center" hidden={!hasSecondZaehler}>
                            Zählpunkt 1
                        </p>
                        <p>Zählernummer: &nbsp; <span className="text-muted">{anlage.x_zaehlernummer_01}</span></p>
                        <p>Zählpunktnummer: &nbsp; <span className="text-muted">{anlage.x_zaehlpunktnummer_01}</span></p>
                        <p>Smartmeter: &nbsp; <span className="text-muted">{UTILS.checkUncheckIcons(anlage.x_is_smartmeter_01)}</span></p>
                    </Col>
                    {hasSecondZaehler &&
                        <Col xs="12" md="6" xl="6">
                            <p className="text-energo text-center">Zählpunkt 2</p>
                            <p>Zählernummer: &nbsp; <span className="text-muted">{anlage.x_zaehlernummer_02}</span></p>
                            <p>Zählpunktnummer: &nbsp; <span className="text-muted">{anlage.x_zaehlpunktnummer_02}</span></p>
                            <p>Smartmeter: &nbsp; <span className="text-muted">{UTILS.checkUncheckIcons(anlage.x_is_smartmeter_02)}</span></p>
                        </Col>
                    }
                </Row>
                <Row className="mt-5">
                    <Col xs="12" md="12" xl="12" className="text-center">
                        Anlage bei Energielieferant anmelden
                        <FormCheck
                            type="switch"
                            id="switch"
                            defaultChecked={anlage.register}
                            onChange={e => {setData(prev => ({
                                ...prev,
                                anlagen: prev.anlagen.map(obj => 
                                    obj.id === anlage.id
                                    ? { ...obj, register: e.target.checked }
                                    : obj
                                )
                            })); setErrors({}); }}
                        />
                    </Col>
                </Row>
                <Row className="mt-4" hidden={!anlage.register || anlage.register === false}>
                    <Col xs="12" md="6" xl="6">
                        <FloatingLabel label="Anlage anmelden am">
                            <FormControl
                                type="date"
                                placeholder="Anlage anmelden am"
                                value={anlage.registerDate}
                                onChange={e => {
                                    setData(prev => ({
                                        ...prev,
                                        anlagen: prev.anlagen.map(obj => 
                                            obj.id === anlage.id
                                            ? { ...obj, registerDate: e.target.value }
                                            : obj
                                        )
                                    }))
                                    setErrors({});
                                }}
                                isValid={anlage.registerDate && VALIDATOR.dateValid(anlage.registerDate)}
                                isInvalid={errors.registerDate && errors.registerDate === anlage.id}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs="12" md="6" xl="6">
                        <p hidden={!anlage.registerDate || UTILS.compareDate(new Date(anlage.registerDate), ">=", new Date())}>
                            Das Anmeldedatum liegt in der Vergangenheit. Die Anmeldung
                            wird in Abstimmung mit dem Energielieferanten am frühest
                            möglichen Zeitpunkt durchgeführt.
                        </p>
                    </Col>
                </Row>
                <Row className="mt-3" hidden={!anlage.register || anlage.register === false}>
                    <Col xs="12" md={hasSecondZaehler? "6" : "10"} xl={hasSecondZaehler? "6": 8} className={hasSecondZaehler? "border-right": null}>
                        <FloatingLabel label={`Zählerstand ${anlage.x_is_smartmeter_01 === true? "(optional)": ""}`}>
                            <FormControl
                                placeholder="Zählerstand"
                                value={anlage.x_zaehlerstand_01}
                                onChange={e => {setData(prev => ({
                                    ...prev,
                                    anlagen: prev.anlagen.map(obj =>
                                        obj.id === anlage.id
                                        ? { ...obj, x_zaehlerstand_01: e.target.value}
                                        : obj
                                    )
                                })); setErrors({})}}
                                isValid={VALIDATOR.IsZaehlerstand(anlage.x_zaehlerstand_01)}
                                isInvalid={errors.x_zaehlerstand_01 && errors.x_zaehlerstand_01 === anlage.id}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs="12" md="6" xl="6" hidden={!hasSecondZaehler}>
                        <FloatingLabel label="Zählerstand 2">
                            <FormControl
                                placeholder="Zählerstand 2"
                                value={anlage.x_zaehlerstand_02}
                                onChange={e => {setData(prev => ({
                                    ...prev,
                                    anlagen: prev.anlagen.map(obj =>
                                        obj.id === anlage.id
                                        ? { ...obj, x_zaehlerstand_02: e.target.value}
                                        : obj
                                    )
                                })); setErrors({})}}
                                isValid={VALIDATOR.IsZaehlerstand(anlage.x_zaehlerstand_02)}
                                isInvalid={errors.x_zaehlerstand_02 && errors.x_zaehlerstand_02 === anlage.id}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}
export default AnlageRegisterElvCard;